<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseProfileDropdown from '@/layout/base/BaseProfileDropdown.vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});

// Logout function
const logout = () => {
    try {
        const logoutRoute = proxy.route ? proxy.route('logout') : '/logout';
        proxy.$inertia.post(logoutRoute);
    } catch (error) {
        console.error('Error logging out:', error);
        proxy.$inertia.post('/logout');
    }
};

// Settings function - redirect to password update page
const goToSettings = () => {
    try {
        const routeName = proxy.route ? proxy.route('profile.password') : '/user/profile';
        proxy.$inertia.visit(routeName);
    } catch (error) {
        console.error('Error navigating to settings:', error);
        window.location.href = '/user/profile';
    }
};

const goToFormulaTax = () => {
    try {
        const routeName = proxy.route ? proxy.route('admin.formula-tax') : '/admin/formula-tax';
        proxy.$inertia.visit(routeName);
    } catch (error) {
        console.error('Error navigating to formula and tax:', error);
        window.location.href = '/admin/formula-tax';
    }
};

// Admin-specific menu items
const menuItems = computed(() => [
    {
        label: 'Settings',
        icon: 'pi pi-cog',
        action: goToSettings
    },
    {
        label: 'Formula and Tax',
        icon: 'pi pi-calculator',
        action: goToFormulaTax
    },
    {
        label: 'Log Out',
        icon: 'pi pi-sign-out',
        action: logout
    }
]);
</script>

<template>
    <BaseProfileDropdown :class="props.class" :menu-items="menuItems" />
</template>
